import { NavigationButton, RecommendedTask } from "@components";
import { useActivityFlowContext } from "@context/ActivityFlowContext";
import { ArrowBack } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { theme } from "@theme";
import medal from "@assets/medal.svg";

export const CompletionView = () => {
  const {
    selectedActivity: activity,
    recommendedActivities,
    completedActivityIds,
    findAnotherActivity,
    goToDashboard,
    navigateToSelectedActivity,
  } = useActivityFlowContext();
  const completedCount = completedActivityIds.length;
  const toolName = activity?.tool.replace("-ai", "").toUpperCase();
  const recommendedActivity = recommendedActivities[0];

  if (!activity) {
    return (
      <Box
        sx={{
          marginTop: 8,
          textAlign: "center",
        }}
      >
        <NavigationButton variant="outlined" onClick={goToDashboard}>
          Back to dashboard
        </NavigationButton>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "48px 0",
      }}
    >
      <Box
        sx={{
          display: "grid",
          width: 64,
          height: 64,
          margin: "0 auto 24px",
          borderRadius: "50%",
          placeItems: "center",
          color: theme.palette.secondary.main,
          background: theme.palette.primary.main,
          fontSize: "2rem",
        }}
        aria-hidden="true"
      >
        ✓
      </Box>
      <Box
        sx={{
          display: "grid",
          gap: 1,
        }}
      >
        <Typography variant="h1">Practice session complete!</Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: 3,
          }}
        >
          Awesome work taking the time to hone your {toolName} skills today.
        </Typography>

        <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            background: theme.palette.text.primary,
            color: theme.palette.primary.contrastText,
            width: "fit-content",
            justifySelf: "center",
            borderRadius: 2,
            gap: 0.75,
          }}
        >
          <img src={medal} alt="Medal" style={{ marginRight: 8 }} />
          <Typography>Skill achieved:</Typography>
          <Typography sx={{ fontWeight: 600 }}>{activity.title}</Typography>
        </Box>

        <Typography>
          {completedCount} {completedCount === 1 ? "activity" : "activities"}{" "}
          completed
        </Typography>
      </Box>

      {recommendedActivity && (
        <RecommendedTask
          recommendedTask={recommendedActivity.activity}
          selectedLevel={recommendedActivity.level}
          navigateToSelectedActivity={(task) =>
            navigateToSelectedActivity(task, recommendedActivity.level)
          }
        />
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: recommendedActivity ? "space-between" : "space-around",
          marginTop: 8,
        }}
      >
        <NavigationButton
          variant="outlined"
          onClick={goToDashboard}
          startIcon={<ArrowBack />}
        >
          Back to Dashboard
        </NavigationButton>
        <NavigationButton onClick={findAnotherActivity}>
          Try Another Task
        </NavigationButton>
      </Box>
    </Box>
  );
};
